import React, { useEffect, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { Menu, X, LayoutDashboard, Users, CreditCard, Wallet, History, LogOut, ArrowUpCircle, ArrowDownCircle, Percent, Bell, User, Gamepad, EggFriedIcon, PlusCircle, List, ChevronDown, ChevronRight, Link, Gamepad2 } from "lucide-react";
// import logo from '../assets/logo.png';
const baseURL = process.env.REACT_APP_BASE_SITE;

// const logo = process.env.APP_LOGO;

// console.log(logo)


interface SidebarProps {
  isOpen: boolean;
  toggleSidebar: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();

  const [gamesExpanded, setGamesExpanded] = useState(false);
  const [paymentExpanded, setPaymentExpanded] = useState(false);
  const [settingExpanded, setSettingExpanded] = useState(false);

  const toggleGamesExpanded = () => {
    setGamesExpanded(!gamesExpanded);
  };
  const togglePaymentExpanded = () => {
    setPaymentExpanded(!paymentExpanded);
  };
  const toggleSettingExpanded = () => {
    setSettingExpanded(!settingExpanded);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    navigate("/login");
    toggleSidebar()
  };

  const sidebarRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (isOpen && sidebarRef.current && !sidebarRef.current.contains(event.target as Node)) {
        toggleSidebar();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, toggleSidebar]);

  return (
    <>
      <button
        className="fixed top-4 left-4 z-20 text-gray-700 lg:hidden"
        onClick={toggleSidebar}
      >
        {isOpen ? <X className="text-white" size={24} /> : <Menu className="text-white"  size={24} />}
      </button>

      <div ref={sidebarRef} className={`w-64 min-h-screen bg-[#2B3141] shadow-md px-1 fixed top-0 left-0 z-[999] transition-all duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0`}>
        <div className=" flex justify-center items-center p-3">
          <img src={baseURL+"/logo.png"} alt="Logo" className="h-auto w-[120px] mr-2" />
        </div>
        <nav className="text-sm">
          <div className="mb-4">
            <NavLink
              to="/"
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <LayoutDashboard size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              Dashboard
            </NavLink>
            <NavLink
              to="/users"
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <Users size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              Users
            </NavLink>
            {/* <NavLink
              to="/deposit"
              onClick={toggleSidebar}
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <ArrowUpCircle size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              Deposit
            </NavLink>
            <NavLink
              onClick={toggleSidebar}
              to="/withdraw"
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <ArrowDownCircle size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              Withdraw
            </NavLink> */}
            {/* <div>
              <button
                onClick={toggleGamesExpanded}
                className={`group flex items-center justify-between w-full py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#646ECD] hover:bg-gray-100 ${
                  gamesExpanded ? "bg-gray-600 font-semibold" : ""
                }`}
              >
                <div className="flex items-center">
                  <Gamepad size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
                  Manage Games
                </div>
                {gamesExpanded ? <ChevronDown size={18} className="group-hover:text-[#646ECD]" /> : <ChevronRight size={18} className="group-hover:text-[#646ECD]" />}
              </button>
              <div className={`ml-6 gap-2 overflow-hidden transition-all duration-300 ease-in-out ${
                gamesExpanded ? "max-h-20" : "max-h-0"
              }`}>
                <NavLink
                  onClick={toggleSidebar}
                  to="/games"
                  className={({ isActive }) =>
                    `group flex items-center py-2 px-4 gap-1 rounded-lg transition duration-200 text-white hover:text-[#646ECD] ${
                      isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                    }`
                  }
                >
                  <PlusCircle size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
                  Games
                </NavLink>
                <NavLink
                  onClick={toggleSidebar}
                  to="win-settings"
                  className={({ isActive }) =>
                    `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#646ECD] ${
                      isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                    }`
                  }
                >
                  <List size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
                  Win Setting
                </NavLink>
              </div>
            </div> */}
            <NavLink
              onClick={toggleSidebar}
              to="/affiliate"
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <Link size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              Affiliate
            </NavLink>
            {/* <NavLink
              onClick={toggleSidebar}
              to="/seo-manager"
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <User size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              SEO Manager
            </NavLink>
            <NavLink
              onClick={toggleSidebar}
              to="/notification-settings"
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <Bell size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              Notification Settings
            </NavLink> */}
            <NavLink
              to="/game-control"
              onClick={toggleSidebar}
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <Gamepad2 size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              Game Control
            </NavLink>
            <NavLink
              onClick={toggleSidebar}
              to="/wallet"
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <Wallet size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              Wallet
            </NavLink>
            {/* <NavLink
              onClick={toggleSidebar}
              to="/history"
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <History size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              History
            </NavLink> */}

            <div>
              <button
                onClick={togglePaymentExpanded}
                className={`group flex items-center justify-between w-full py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#646ECD] hover:bg-gray-100 ${
                  paymentExpanded ? "bg-gray-600 font-semibold" : ""
                }`}
              >
                <div className="flex items-center">
                  <Gamepad size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
                  Manage Payment
                </div>
                {paymentExpanded ? <ChevronDown size={18} className="group-hover:text-[#646ECD]" /> : <ChevronRight size={18} className="group-hover:text-[#646ECD]" />}
              </button>
              <div className={`ml-6 gap-2 overflow-hidden transition-all duration-300 ease-in-out ${
                paymentExpanded ? "max-h-20" : "max-h-0"
              }`}>
                <NavLink
                  onClick={toggleSidebar}
                  to="/manual-withdrawal"
                  className={({ isActive }) =>
                    `group flex items-center py-2 px-4 gap-1 rounded-lg transition duration-200 text-white hover:text-[#646ECD] ${
                      isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                    }`
                  }
                >
                  <PlusCircle size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
                  Withdrawal
                </NavLink>
                <NavLink
                  onClick={toggleSidebar}
                  to="/manual-deposit"
                  className={({ isActive }) =>
                    `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#646ECD] ${
                      isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                    }`
                  }
                >
                  <List size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
                  Deposit
                </NavLink>
              </div>
            </div>
            <div>
              <button
                onClick={toggleSettingExpanded}
                className={`group flex items-center justify-between w-full py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#646ECD] hover:bg-gray-100 ${
                  settingExpanded ? "bg-gray-600 font-semibold" : ""
                }`}
              >
                <div className="flex items-center">
                  <Gamepad size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
                  Setting
                </div>
                {settingExpanded ? <ChevronDown size={18} className="group-hover:text-[#646ECD]" /> : <ChevronRight size={18} className="group-hover:text-[#646ECD]" />}
              </button>
              <div className={`ml-6 gap-2 overflow-hidden transition-all duration-300 ease-in-out ${
                settingExpanded ? "max-h-20" : "max-h-0"
              }`}>
                <NavLink
              onClick={toggleSidebar}
              to="/settings"
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <History size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              Setting
            </NavLink>
            <NavLink
              onClick={toggleSidebar}
              to="/changePassword"
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <History size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              
              Change password
            </NavLink>
              </div>
            </div>

            <NavLink
              onClick={toggleSidebar}
              to="/level"
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white mt-2 hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <History size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              
              Level
            </NavLink>
            <NavLink
              onClick={toggleSidebar}
              to="/depositBonus"
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white mt-2 hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <History size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              
              Set Deposit Bonus
            </NavLink>
            <NavLink
              onClick={toggleSidebar}
              to="/BetCommissionLevel"
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white mt-2 hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <History size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              
              Bet Commission
              Level
            </NavLink>
            <NavLink
              onClick={toggleSidebar}
              to="/DepositCommissionLevel"
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white mt-2 hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <History size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              
              Deposit Commission
              Level
            </NavLink>
            <NavLink
              onClick={toggleSidebar}
              to="/stateList"
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white mt-2 hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <History size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              
              State restrictions
            </NavLink>
             <NavLink
              onClick={toggleSidebar}
              to="/countryList"
              className={({ isActive }) =>
                `group flex items-center py-2 px-4 rounded-lg transition duration-200 text-white mt-2 hover:text-[#646ECD] ${
                  isActive ? "bg-gray-600 font-semibold" : "hover:bg-gray-100"
                }`
              }
            >
              <History size={18} className="mr-3 text-white group-hover:text-[#646ECD]" />
              
              Country restrictions
            </NavLink>
            
          </div>
        </nav>

        <button
          onClick={handleLogout}
          className="flex items-center w-full py-2 px-4 text-white hover:text-[#646ECD] hover:bg-gray-100 rounded-lg transition duration-200 text-left mt-auto absolute bottom-4"
        >
          <LogOut size={18} className="mr-3" />
          Log out
        </button>
      </div>
    </>
  );
};

export default Sidebar;
